import React, { useState, useEffect } from "react";  
import { Form, Button, Card } from "react-bootstrap";
import { TimePicker } from "antd";
import moment from "moment";  
import { useParams, useNavigate } from "react-router-dom";
import { useGlobalState } from "../../../services/hostelConst";
import {
  callToast,
  showErrorMessages,
} from "../../../services/utilityFunctions";
import "./hostel.css";
import {
  addFoodMenuMeal,
  updateFoodMenuMeal,
} from "./hostelServices/foodMenuServices";  

const MEAL_TYPES = [
  { value: "BREAKFAST", label: "Breakfast" },
  { value: "LUNCH", label: "Lunch" },
  { value: "DINNER", label: "Dinner" },
];

const AddHostelMenuMeal = ({ navigate, refresh }) => {
  const { closeModal, modalState } = useGlobalState();
  const masterData = modalState.data;
  const isEditing = modalState.isEditing;

  const hostelId =
    modalState.id ||
    (masterData && masterData._HOSTEL) ||
    (masterData && masterData.hostelId) ||
    modalState.hostelId;
  const menuId =
    modalState.foodMenuId ||
    (masterData && masterData._MENU) ||
    modalState.menuId;
  console.log("hostelId and menuId", hostelId, menuId);
  console.log("Master data:", masterData);
  console.log("Is editing:", isEditing);

  const [formData, setFormData] = useState({
    startTime: null,
    endTime: null,
    type: "",
    hostelId,
    menuId,
    id: null,
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const parseTimeString = (timeString) => {
    if (!timeString) return null;

    console.log(`Attempting to parse time string: "${timeString}"`);

    const formats = [
      "hh:mm A",
      "h:mm A",
      "HH:mm",
      "HH:mm:ss",
      "hh:mm a",
      "h:mm a",
    ];

    for (const format of formats) {
      const parsed = moment(timeString, format);
      if (parsed.isValid()) {
        console.log(
          `Successfully parsed "${timeString}" with format: ${format}`
        );
        return parsed;
      }
    }

    const parsed = moment(timeString);
    if (parsed.isValid()) {
      console.log(`Parsed "${timeString}" with generic parsing`);
      return parsed;
    }

    console.error(`Failed to parse time: "${timeString}"`);
    return null;
  };
  useEffect(() => {
    if (masterData && isEditing) {
      console.log("Setting form data from masterData:", masterData);

      const getProperty = (obj, propName) => {
        if (!obj) return null;

        if (obj[propName] !== undefined) return obj[propName];

        const lowerPropName = propName.toLowerCase();
        for (const key of Object.keys(obj)) {
          if (key.toLowerCase() === lowerPropName) {
            return obj[key];
          }
        }
        return null;
      };

      const startTime =
        getProperty(masterData, "START TIME") ||
        getProperty(masterData, "start_time");
      const endTime =
        getProperty(masterData, "END TIME") ||
        getProperty(masterData, "end_time");
      const type =
        getProperty(masterData, "TYPE") || getProperty(masterData, "type");


      const mealTypeMap = {
        Breakfast: "BREAKFAST",
        Lunch: "LUNCH",
        Dinner: "DINNER",
      };

      const typeValue = type && mealTypeMap[type] ? mealTypeMap[type] : type;

      setFormData({
        startTime: startTime || null,
        endTime: endTime || null,
        type: typeValue || "",
        hostelId,
        menuId,
        id: getProperty(masterData, "_ID") || null,
      });

      console.log("Setting form with values:", {
        startTime,
        endTime,
        type: typeValue,
        hostelId,
        menuId,
        id: getProperty(masterData, "_ID"),
      });
    }
  }, [masterData, isEditing, hostelId, menuId]);

  const handleTimeChange = (timeField) => (time) => {
    setFormData((prev) => ({
      ...prev,
      [timeField]: time ? time.format("hh:mm A") : null,
    }));
    if (errors[timeField]) {
      setErrors((prev) => ({ ...prev, [timeField]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.startTime) newErrors.startTime = "Start time is required";
    if (!formData.endTime) newErrors.endTime = "End time is required";
    if (!formData.type) newErrors.type = "Meal type is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);

    try {
      const correctHostelId = masterData && masterData._HOSTEL 
      ? masterData._HOSTEL 
      : hostelId;
      const correctMenuId = masterData && masterData._MENU 
      ? masterData._MENU 
      : menuId;
      const dataToSend = {
        ...formData,
        hostelId: correctHostelId,  
        menuId: correctMenuId,
      };
      console.log("the data to send is: ", dataToSend);
      const response = isEditing
        ? await updateFoodMenuMeal(dataToSend)
        : await addFoodMenuMeal(dataToSend);

      if (response.status === "success") {
        const myButton = document.getElementById("myToastButton");
        callToast(
          "success",
          "Success",
          `Meal time ${isEditing ? "updated" : "added"} successfully!`,
          myButton
        );
        await refresh({ columnRefresh: false, isLoading: false });
        closeModal();
      } else {
        showErrorMessages({ data: response, navigate });
      }
    } catch (error) {
      showErrorMessages({
        data: {
          message: `Failed to ${isEditing ? "update" : "add"} meal time`,
          errors: error.message,
        },
        navigate,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
      <Card.Body className="px-4 py-4">
        <Form onSubmit={handleSubmit}>
          <div className="row mb-4">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className="fw-bold">Start Time</Form.Label>
                <div className="time-picker-wrapper">
                  <TimePicker
                    format="hh:mm A"
                    className={`custom-time-picker ${
                      errors.startTime ? "is-invalid" : ""
                    }`}
                    style={{ width: "100%" }}
                    popupClassName="time-picker-dropdown"
                    placeholder="Select start time"
                    value={
                      formData.startTime
                        ? parseTimeString(formData.startTime)
                        : null
                    }
                    onChange={handleTimeChange("startTime")}
                    use12Hours
                    minuteStep={5}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    onSelect={(time) =>
                      console.log(
                        "Selected start time:",
                        time?.format("hh:mm A")
                      )
                    }
                  />
                  {errors.startTime && (
                    <div className="invalid-feedback d-block">
                      {errors.startTime}
                    </div>
                  )}
                </div>
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label className="fw-bold">End Time</Form.Label>
                <div className="time-picker-wrapper">
                  <TimePicker
                    format="hh:mm A"
                    className={`custom-time-picker ${
                      errors.endTime ? "is-invalid" : ""
                    }`}
                    style={{ width: "100%" }}
                    popupClassName="time-picker-dropdown"
                    placeholder="Select end time"
                    value={
                      formData.endTime
                        ? parseTimeString(formData.endTime)
                        : null
                    }
                    onChange={handleTimeChange("endTime")}
                    use12Hours
                    minuteStep={5}
                    getPopupContainer={(trigger) => trigger.parentNode}
                  />
                  {errors.endTime && (
                    <div className="invalid-feedback d-block">
                      {errors.endTime}
                    </div>
                  )}
                </div>
              </Form.Group>
            </div>
          </div>

          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Meal Type</Form.Label>
            <Form.Select
              value={formData.type}
              onChange={(e) => {
                setFormData((prev) => ({ ...prev, type: e.target.value }));
                // Clear error when value changes
                if (errors.type) {
                  setErrors((prev) => ({ ...prev, type: null }));
                }
              }}
              isInvalid={!!errors.type}
              className="shadow-sm"
            >
              <option value="">Select meal type</option>
              {MEAL_TYPES.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.type}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button
              variant="primary"
              type="submit"
              disabled={isLoading}
              className="px-4"
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {isEditing ? "Updating..." : "Adding..."}
                </>
              ) : isEditing ? (
                "Update Meal Time"
              ) : (
                "Add Meal Time"
              )}
            </Button>
          </div>
        </Form>
      </Card.Body>
  );
};

export default AddHostelMenuMeal;
